// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"590":"da11e603","724":"718dca0c"}[chunkId] + ".js";
};